import { render, staticRenderFns } from "./GetStarted.vue?vue&type=template&id=51681f4e&lang=pug&"
import script from "./GetStarted.vue?vue&type=script&lang=ts&"
export * from "./GetStarted.vue?vue&type=script&lang=ts&"
import style0 from "./GetStarted.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports